<template lang="html">
  <div class="assistance">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>
    
    <img :src="`${pagebase}/static/img/assistance/back.png`" alt="" class="backInvite">
    
    <div class="content">
      <!-- <img :src="`${pagebase}/static/img/assistance/conImg_1.png`" alt="" class="conImg"> -->
      
      <div class="assistancePeople" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/helpCon_1.png` +')'}">
        <input type="number" class="phoneInput" placeholder="写下您接收福利的电话" name="phoneInput" v-model="phone">
        <div class="securityCodeInput">
          <input type="text" placeholder="小小验证码" name="securityCode" v-model="smsCode">
          <p @click="getSmsCode">{{buttonMsg}}</p>
        </div>
              
        <div class="beginBtn" @click="goLogin">
          立即登录 好礼免费领
        </div>
      </div>
      
      <div class="elseGift" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/helpCon_2.png` +')'}">
        <div class="wealCard">
          <div class="wealCon1">
            <img :src="`${pagebase}/static/img/assistance/gift5.png`" alt="">
            <div>
              <p>大厂内部接口规范/华为硬件设计规范</p>
              <p>电子元器件选型规范、逻辑电平接口设计规范…</p>
            </div>
          </div>
          <div class="wealCon2">
            <div>
              <p>硬件工程师必读电子书20本</p>
              <p>涉及电源设计、半导体、信号、射频…</p>
            </div>
            <img :src="`${pagebase}/static/img/assistance/gift6.png`" alt="">
          </div>
          <div class="wealCon1">
            <img :src="`${pagebase}/static/img/assistance/gift7.png`" alt="">
            <div>
              <p>30份半导体行业研究报告合集</p>
              <p>电池管理、功率半导体、光芯片…</p>
            </div>
          </div>
          <div class="wealCon2">
            <div>
              <p>电子人效率工具合集</p>
              <p>电路计算Excel合集，BGA管脚信号自动上色程序、EDA软件互转工具</p>
            </div>
            <img :src="`${pagebase}/static/img/assistance/gift8.png`" alt="">
          </div>
        </div>
      </div>
      
      <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
        <div class="informerCon">
          <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
          <p class="informerClose" @click="informerShow = 0">我知道了</p>
        </div>
      </div>
      
      <div class="helpShow" v-show="helpShow">
        <div class="informerCon">
          <p class="informerInfo">同一手机号只能助力一次哦~</p>
          <p class="informerClose" @click="goMyself">我知道了</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    pagebase
  } from '@/utils/http.js';
  import utils from '@/utils/utils.js';
  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare'

  export default {
    data() {
      return {
        pagebase: pagebase,
        informerShow: 0,
        helpShow: false,

        phone: '',
        smsCode: '',
        limitTime: 60,
        buttonMsg: '发送验证码',
      }
    },

    mounted(){
      document.title = '电巢读书月 专家荐好书';
      this.getShowStat(0);
      new WxShare().share({
        title: '快来一起免费领半导体行业桌垫/京东E卡购书金吧！',
        desc: '和HW工程师解封绝密技术资料！',
        link: 'http://app.eda365.com:8088/pages/m/#/assistance?aid=' + Cookies.get('aid') + '&activityId=' + this.$route.query.activityId,
        imgUrl: pagebase + '/static/img/assistance/breviaryImg.png'
      });

      if (Cookies.get('help_activity_reg_id')) {
        this.helpShow = true;
      } else {
        this.helpShow = false;
      }
    },

    methods: {
      // 页面浏览量统计
      getShowStat(id) {
        // var channel = this.$route.query.channel || '';
        // var activityId = this.$route.query.activityId || '';
        // var aid = this.$route.query.aid || '';
        this.$http.get('/api/showStat', {
          params: {
            url: window.location.href,
            type: id,
          }
        })
      },

      // 获取验证码
      getSmsCode() {
        this.$http.get('/Registered/getPhoneSmsCode', {
          params: utils.cso({
            phone: this.phone,
            phone_head: 86,
            type: 10,
            client: 'H5'
          })
        }).then((res) => {
          if (res.code >= 0) {
            this.buttonMsg = this.limitTime + 's'
            this.timer = window.setInterval(() => {
              this.limitTime--
              this.buttonMsg = this.limitTime + 's'
              if (this.limitTime < 0) {
                window.clearInterval(this.timer)
                this.buttonMsg = '发送验证码'
                this.limitTime = 60
              }
            }, 1000)
          } else {
            utils.showMessage(res.msg)
          }
        })
      },

      goMyself() {
        this.$router.replace({
          path: '/assistanceInvite',
          query: {
            activityId: this.$route.query.activityId,
          }
        });
      },

      // 确定登录
      goLogin() {
        if (this.phone) {
          if (this.smsCode) {
            this.$http({
              url: '/member/newHelpingHands',
              method: 'post',
              params: {
                activity_reg_id: this.$route.query.aid,
                type: 2,
                live_activity_id: this.$route.query.activityId,
                phone: this.phone,
                sms_code: this.smsCode,
              },
            }).then((res) => {
              if (res.code >= 0) {
                Cookies.set('uid', res.data.uid, {
                  expires: 7
                });
                Cookies.set('token', res.data.token.token, {
                  expires: 7
                });
                Cookies.set('reg_channel', res.data.reg_channel, {
                  expires: 7
                });
                Cookies.set('aid', res.data.activity_reg_id, {
                  expires: 7
                });
                Cookies.set('phone', res.data.phone, {
                  expires: 7
                });
                Cookies.set('help_activity_reg_id', res.data.help_activity_reg_id, {
                  expires: 7
                });


                utils.showMessage('助力成功')

                this.$router.replace({
                  path: '/assistanceInvite',
                  query: {
                    activityId: this.$route.query.activityId,
                  }
                });
              } else if (res.code == -3) {
                utils.showMessage(res.msg);
              } else {
                Cookies.set('uid', res.data.uid, {
                  expires: 7
                });
                Cookies.set('token', res.data.token.token, {
                  expires: 7
                });
                Cookies.set('reg_channel', res.data.reg_channel, {
                  expires: 7
                });
                Cookies.set('aid', res.data.activity_reg_id, {
                  expires: 7
                });
                Cookies.set('phone', res.data.phone, {
                  expires: 7
                });
                Cookies.set('help_activity_reg_id', res.data.help_activity_reg_id, {
                  expires: 7
                });

                utils.showMessage(res.msg);

                this.$router.replace({
                  path: '/assistanceInvite',
                  query: {
                    activityId: this.$route.query.activityId,
                  }
                });
              }
            })
          } else {
            utils.showMessage('输入的验证码不能为空')
          }
        } else {
          utils.showMessage('输入的手机号不能为空')
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .assistance {
    box-sizing: border-box;
    width: 100%;
    height: 120rem;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    background-size: contain;
    background: linear-gradient(#0C4993, #160D49);
  }

  .informerBtn {
    position: absolute;
    top: 2rem;
    right: 0;
    display: flex;
    justify-content: flex-end;
  }

  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #C9F7F7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }
  
  .backInvite {
    width: 100%;
  }
  
  .content {
    box-sizing: border-box;
    padding: 0 1.5rem;
  }
  
  .conImg {
    width: 100%;
    margin-top: 1.5rem;
  }
  
  .assistancePeople {
    box-sizing: border-box;
    width: 100%;
    height: 22.3rem;
    background-size: 100% 100%;
    padding: 0 2.2rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-top: 1.7rem;
  }

  .phoneInput {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #151767;
    outline: none;
    margin-bottom: 1.4rem;
  }

  .phoneInput[name="phoneInput"]::-webkit-input-placeholder {
    color: #151767;
  }

  .securityCodeInput {
    display: flex;
    height: 4.7rem;
    margin-bottom: 1.5rem;
  }

  .securityCodeInput input {
    width: 65%;
    border-radius: 4.7rem 0 0 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #151767;
    outline: none;
  }

  .securityCodeInput p {
    width: 35%;
    border-radius: 0 4.7rem 4.7rem 0;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 1.4rem;
    color: #F7443F;
    padding-right: 2rem;
  }

  .securityCodeInput input[name="securityCode"]::-webkit-input-placeholder {
    color: #151767;
  }

  .beginBtn {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    margin-bottom: 2.35rem;
    font-size: 1.8rem;
    font-weight: 600;
    color: #130655;
    display: flex;
    justify-content: center;
    align-items: center;
    border: .1rem solid transparent;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(130deg, #80EEFF, #634DFD), linear-gradient(to right, #0E5FFF, #66FFFF, #0E5FFF);
  }

  .elseGift {
    box-sizing: border-box;
    width: 100%;
    height: 34.35rem;
    background-size: 100% 100%;
    margin-top: 2rem;
    padding: 5rem 2rem 0 2rem;
  }
  
  .wealCard {
    box-sizing: border-box;
  }
  
  .wealCon1 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 1.4rem 0;
  }
  
  .wealCon1 div {
    display: flex;
    flex-direction: column;
  }
  
  .wealCon1 img {
    width: 4.4rem;
    height: 4.4rem;
    margin-right: 1rem;
  }
  
  .wealCon1 p:nth-child(1) {
    font-size: 1.4rem;
    font-weight: 600;
    color: #B2FFFF;
  }
  
  .wealCon1 p:nth-child(2) {
    font-size: 1.2rem;
    color: #C9F7F7;
  }
  
  .wealCon2 {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.4rem 0;
  }
  
  .wealCon2 div {
    display: flex;
    flex-direction: column;
  }
  
  .wealCon2 img {
    width: 4.4rem;
    height: 4.4rem;
  }
  
  .wealCon2 p:nth-child(1) {
    font-size: 1.4rem;
    font-weight: 600;
    color: #B2FFFF;
  }
  
  .wealCon2 p:nth-child(2) {
    font-size: 1.2rem;
    color: #C9F7F7;
  }

  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }

  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }

  /* 助力提示 */
  .helpShow {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 11;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
</style>
